// extracted by mini-css-extract-plugin
module.exports = {"tooltipArrow":"_6e36fc7","list":"_35796c2","anchor":"_d019cc4","buttonAnimation":"_fb11d0a","flashAnimation":"_b01eda8"};